<section class="w-100 d-flex justify-content-center h-100 align-items-center">
  <div class="text-center size-404">
    <h1 class="font-museo-900" >404</h1>
    <p class="text-uppercase mt-1 font-museo-900">No encontrado</p>

    <a routerLink="/user" class="btn btn-default text-info">Regresar</a>
  </div>
</section>
